<ion-item class="file-wrapper">
    <ion-grid class="ion-no-padding">
        <ion-row class="header ion-no-padding">
            <ion-col class="ion-no-padding">
                <svg-icon [applyClass]="true"
                          class="file-ico"
                          [src]="'/assets/icons/messages/file.svg'">
                </svg-icon>
                <div class="info">
                    <h3>{{ file.name }}</h3>
                    <p *ngIf="file.size">{{ getHumanReadableFilesize(file.size) }}</p>
                </div>
            </ion-col>
            <ion-col class="buttons ion-no-padding ion-text-right">
                <a *ngIf="(image || pdf) && file.file_url"
                   (click)="preview()"
                   class="file-link">
                    <svg-icon [applyClass]="true"
                              [src]="'/assets/icons/messages/eye.svg'">
                    </svg-icon>
                </a>
                <a *ngIf="file.file_url"
                   (click)="plt.downloadFile(plt.baseLinkPath + plt.apiPrefix + (file.custom ? file.custom : '/attachments/') + file.id + '?token=' + this.userToken, file.name)"
                   class="file-link pointer">
                    <svg-icon [applyClass]="true"
                              [src]="'/assets/icons/messages/download.svg'">
                    </svg-icon>
                </a>
            </ion-col>
        </ion-row>

        <ion-row *ngIf="image"
                 class="content ion-no-padding"
                 (click)="preview()">
            <ion-col class="ion-no-padding ion-text-center">
                <img [src]="plt.createSignedLink(file.file_url)" />
            </ion-col>
        </ion-row>

        <ion-row *ngIf="file.preview"
                 class="content ion-no-padding"
                 (click)="preview()">
            <ion-col class="preview ion-no-padding ion-text-center">
                <img [src]="plt.createSignedLink(file.preview)" />
            </ion-col>
        </ion-row>

    </ion-grid>
</ion-item>